import {StyleSheet} from 'react-native';
import CCColors from '@/Utils/CCColors';

export const styles = StyleSheet.create({
  modalBackground: {
    backgroundColor: CCColors.White,
    borderRadius: 16,
    alignItems: 'center',
  },
  optionsContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    gap: 50,
    width: '100%',
  },
  optionsContainerMobile: {
    flexDirection: 'column',
    alignItems: 'center',
    gap: 16,
    justifyContent: 'center',
    width: '100%',
  },
  option: {
    backgroundColor: CCColors?.Primary?.lightBrown,
    paddingTop: 20,
    borderRadius: 8,
  },
  optionMobile: {
    width: '100%',
    paddingVertical: 16,
    backgroundColor: CCColors?.Primary?.lightBrown,
    paddingTop: 20,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: CCColors?.BorderBottom,
  },
  image: {
    width: 382,
    height: 382,
    marginTop: 10,
  },
  imageMobile: {
    width: 88,
    height: 94,
    position: 'absolute',
    bottom: -5,
    right: 1,
  },
  textContainer: {
    marginLeft: 32,
  },
  textContainerMobile: {
    marginLeft: 20,
    marginBottom: 12,
  },
  optionTitle: {
    fontSize: 24,
    fontWeight: '600',
    lineHeight: 36,
    color: CCColors?.TextColor?.Dark,
  },
  optionTitleMobile: {
    fontSize: 14,
    fontWeight: '600',
    lineHeight: 20,
    color: CCColors?.TextColor?.Dark,
  },
  optionSubtitle: {
    fontSize: 20,
    lineHeight: 24,
    fontWeight: '400',
    color: CCColors?.TextColor?.LightGrey,
    opacity: 0.8,
    marginTop: 4,
  },
  optionSubtitleMobile: {
    fontSize: 12,
    lineHeight: 20,
    fontWeight: '400',
    color: CCColors?.TextColor?.LightGrey,
    opacity: 0.8,
  },
});

export default styles;
